import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Editor } from '../models/editor.model';
import { Editorcontrolitem } from '../models/editorcontrolitem.model';
import { MessageService } from './message.service';
import { BaseService } from './base.service';
import { ControlSettingsUiDataModel } from '../models/settings/control-settings-ui-data.model';
import { ItemControlsPair } from '../models/item-controls-pair';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataService extends BaseService {

  public wsBase: string = environment.wgProfileHost + "/api/";

  constructor(http: HttpClient, messageService: MessageService) {
    super(http, messageService);
    this.getTranslations();
  }

  editor: Editor;
  selectedItem: Editorcontrolitem = null;
  selectedItemConverters: any[];
  convertersListVisible: boolean = false;
  selectedItemTmp: Editorcontrolitem = null;
  sourceControls: Editorcontrolitem[] = [];
  selecteItemSettingsUi: ControlSettingsUiDataModel = null;
  complexControlRight: Map<string, ItemControlsPair> = new Map<string, ItemControlsPair>();
  translations: any;

  async getTranslations() {

    var url = this.wsBase + "translation/all";
    var data = {
      LanguageCode: "sl"
    };

    this.translations = await this.dataPOST(url, data).toPromise<any>();

    /*this.dataPOST(url, data).subscribe(r=>{
      this.translations = r;
    });*/
    
  }

  async getTranslation(key: string) {

    var url = this.wsBase + "translation?lang=sl&key=" + key;
    var r = await this.dataGET<string>(url).toPromise<string>();
    return r;
  }


  getModelControls(modelFullNameB64: string) {
    var url = this.wsBase + "dynamicforms/modelcontrols/" + modelFullNameB64 + "?onlyModel=false";
    this.dataGET(url).subscribe(
      data => this.mapControls(data)
    );
  }

  getModelForms(modelFullNameB64: string, pathInsideModelB64: string) {
    var url = this.wsBase + "dynamicforms/modelforms/" + modelFullNameB64 + "?pathInsideModel=" + pathInsideModelB64;
    return this.dataGET(url);
  }

  //Many2One
  getMany2OneModelControls(item: Editorcontrolitem) {
    var url = this.wsBase + "dynamicforms/modelcontrols/" + btoa(item.Settings.EntityModel) + "?parentprop=" + item.Settings.EntityName;
    this.dataGET(url).subscribe(
      data => this.mapManyToOneControls(data, item)
    );
  }

  getOne2ManyModelControls(item: Editorcontrolitem) {
    var url = this.wsBase + "dynamicforms/modelcontrols/" + btoa(item.Settings.EntityModel) + "?parentprop=" + item.Settings.BindingPropertyName;
    this.dataGET(url).subscribe(
      data => this.mapOneToManyControls(data, item)
    );
  }


  chechItemToBeRemovedFromComplex(item: Editorcontrolitem) {
    if (item.Type == 'SemManyToOneControl') {
      this.complexControlRight.delete(item.Settings.EntityModel + "" + item.Settings.EntityName);
    } else if (item.Type == 'SemOneToManyContainer') {
      this.complexControlRight.delete(item.Settings.EntityModel + "" + item.Settings.BindingPropertyName);
    }
  }

  chechItemToBeAddedFromComplex(item: Editorcontrolitem) {
    if (item.Type == 'SemManyToOneControl') {
      this.getMany2OneModelControls(item);
    } else if (item.Type == 'SemOneToManyContainer') {
      this.getOne2ManyModelControls(item);
    }
  }

  mapControls(data) {
    this.sourceControls = [];
    data.forEach(item => {
      this.sourceControls.push(Editorcontrolitem.mapItem(item))
    });
  }

  mapConverters(data) {
    this.selectedItemConverters = data;
  }

  mapManyToOneControls(data, item: Editorcontrolitem) {

    let arrayItems: Editorcontrolitem[] = [];
    data.forEach(item => {
      arrayItems.push(Editorcontrolitem.mapItem(item))
    });

    this.complexControlRight.set(item.Settings.EntityModel + "" + item.Settings.EntityName, new ItemControlsPair(item, arrayItems, true));
  }

  mapOneToManyControls(data, item: Editorcontrolitem) {

    let arrayItems: Editorcontrolitem[] = [];
    data.forEach(item => {
      arrayItems.push(Editorcontrolitem.mapItem(item))
    });

    this.complexControlRight.set(item.Settings.EntityModel + "" + item.Settings.BindingPropertyName, new ItemControlsPair(item, arrayItems, true));
  }

  gteFormView(frmName: string, isParameterForm:boolean) {
    var url = this.wsBase + "dynamicforms/editor/view/byname/" + frmName+"?isParameterForm="+isParameterForm;
    this.dataGET<Editor>(url).subscribe(
      data => {
        this.editor = Editor.map(data)
      },
      error => {

      },
      () => {
        this.getModelControls(btoa(this.editor.Controls[0].Settings.ModelFullName));
        this.initComplexControlsRightList(this.editor.Controls);
      }
    );
  }

  getControlConverters(controlType: string) {
    this.selectedItemConverters = null;
    var url = this.wsBase + "dynamicforms/editor/control/converters/" + controlType;
    this.dataGET(url).subscribe(
      data => this.mapConverters(data)
    );
  }

  getClientUIControls() {

  }

  initComplexControlsRightList(controls: Editorcontrolitem[]) {
    controls.forEach(i => {
      if (i.Type == 'SemManyToOneControl') {
        this.getMany2OneModelControls(i);
      }
      else if (i.Type == 'SemOneToManyContainer') {
        this.getOne2ManyModelControls(i);
      }

      //tu dodaj

      if (i.Children != null && i.Children.length > 0) {
        this.initComplexControlsRightList(i.Children);
      }
    });
  }

  getControlSettingsUiData(controlName: string) {
    var url = this.wsBase + "dynamicforms/controlsettings/uidata/" + controlName;
    this.dataGET<ControlSettingsUiDataModel>(url).subscribe(
      data => {
        this.selecteItemSettingsUi = ControlSettingsUiDataModel.map(data)
      },
      error => {

      },
      () => { }
    );
  }
  

  save() {

    
    this.messageService.showLoading();
    var url = this.wsBase + "dynamicforms/editor/view/submit";
    this.editor.consolidateModel();


    this.dataPOST(url, this.editor).subscribe(
      data => this.afterSave(data)
    );
  }

  afterSave(data) {
    this.messageService.hideLoading();
    this.messageService.showMessage("Save complete", "success");
  }

  redirectToPreview() {

  }

  redirectToPlatform() {

  }

  prepareTmpItem() {

    this.selectedItem;
    this.selectedItemTmp = new Editorcontrolitem(this.selectedItem.Id, this.selectedItem.ControlClientId, this.selectedItem.Type, this.selectedItem.ControlType, this.selectedItem.Property, this.selectedItem.Version, this.selectedItem.Children, this.selectedItem.SettingsJson);
  }

  confirmTmpItem() {
    this.selectedItem.Settings = this.selectedItemTmp.Settings;
    this.editor.consolidateItem(this.selectedItem);
  }

  executeConverter(targetConverter: string) {
    var url = this.wsBase + "dynamicforms/editor/control/converters/execute";

    var convertInput = {
      SourceTypeName: this.selectedItem.Type,
      TargetTypeName: targetConverter,
      InputJson: JSON.stringify(this.selectedItem)
    };

    this.dataPOST(url, convertInput).subscribe(
      data => this.afterConverter(data)
    );
  }

  validateSettings(controlType: string, settingsJson: string) {
    var url = this.wsBase + "dynamicforms/editor/control/settings/validate";


    var input = {
      SettingsJson: settingsJson,
      ControlType: controlType
    };

    return this.dataPOST(url, input);
  }

  afterConverter(data) {
    this.selectedItem = JSON.parse(data.ControlJson);
    this.editor.Controls.forEach(i => {
      this.changeControl(i);
    });
  }

  changeControl(i) {

    if (i.Id == this.selectedItem.Id) {
      i.Type = this.selectedItem.Type;
    } else {

      if (i.Children != null && i.Children.length > 0) {
        i.Children.forEach(i => {
          this.changeControl(i);
        });
      }
    }

  }
}